import { ReduxUtils, Consts } from '../../dependencies';

const { apiTypes, entityKeys } = Consts;
const { apiSelector } = ReduxUtils;

export const fetchExportsApiSelector = state => apiSelector(state, entityKeys.EXPORTS, apiTypes.FETCH);

export const fetchExportApiSelector = (state, id) => apiSelector(state, entityKeys.EXPORT, apiTypes.FETCH, id);
export const deleteExportApiSelector = (state, id) => apiSelector(state, entityKeys.EXPORT, apiTypes.DELETE, id);
